/**
 * BulkPaymentUpload — legacy route shim (Sep 2026, BULK-PAY-MODAL-001).
 * The workflow now lives in the compact modal over the Billing Dashboard
 * (components/admin/billing/BulkPaymentUploadModal.jsx). Old bookmarks to
 * /admin/billing/bulk-payments land on the dashboard with the modal open.
 */
import React from 'react';
import { Navigate } from 'react-router-dom';

const BulkPaymentUpload = () => <Navigate to="/admin/billing?bulk_payments=1" replace />;

export default BulkPaymentUpload;
